import cx from 'classnames';
import { useEffect } from 'react';
import { Switch, useLocation } from 'react-router-dom';
import './assets/styles/styles.scss';
import Banner from './components/Banner/Banner';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import { useTour } from './contexts/TourContext';
import { session } from './helpers/helpers';
import Routes from './Routes';

const checkRoute = (pathname) => {
  const getPath = pathname.split('/')[1];

  if (pathname === '/') return 'landing-page';

  return `${getPath}-page`;
};

const AppLayout = () => {
  const { pathname } = useLocation();
  const token = session.get('token');
  const { isTourActive, canNavigate } = useTour();

  const pageClassName = cx('page', checkRoute(pathname));

  // Calculate banner -> boxes spacing based on the bottom of the banner's
  // main inner text block so the visual gap is consistent across pages.
  useEffect(() => {
    let observer = null;

    function updateBannerSpacing() {
      try {
        const banner = document.querySelector('.banner');
        if (!banner) {
          // remove dynamic var if no banner present
          document.documentElement.style.removeProperty('--banner-dynamic-margin');
          return;
        }

        // Try to find the inner content that holds the banner text
        const inner =
          banner.querySelector('.banner__inner') ||
          banner.querySelector('.banner__content') ||
          banner;

        const bannerRect = banner.getBoundingClientRect();
        const innerRect = inner.getBoundingClientRect();

        // y_text: distance from top of banner to bottom of the inner text
        const yText = innerRect.bottom - bannerRect.top;
        const hBanner = bannerRect.height;

        // B is distance from bottom of text to bottom of banner
        const b = hBanner - yText;

        // Desired gap from bottom of text to top of boxes (px)
        const DESIRED_GAP = 36; // matches previous desktop overlap intent

        // marginTop to apply on .boxes = G - B (see derivation)
        const marginTop = Math.round(DESIRED_GAP - b);

        document.documentElement.style.setProperty('--banner-dynamic-margin', `${marginTop}px`);
      } catch (e) {
        // silent fail — don't block rendering
        // console.error(e);
      }
    }

    // initial calculation and on resize
    updateBannerSpacing();
    window.addEventListener('resize', updateBannerSpacing);

    // watch for content changes inside the banner (text may change on route load)
    const bannerEl = document.querySelector('.banner');
    if (bannerEl && window.MutationObserver) {
      observer = new MutationObserver(updateBannerSpacing);
      observer.observe(bannerEl, { childList: true, subtree: true, characterData: true });
    }

    // Also recalc after a short delay to allow fonts/images to load
    const t = setTimeout(updateBannerSpacing, 300);

    return () => {
      window.removeEventListener('resize', updateBannerSpacing);
      clearTimeout(t);
      if (observer) observer.disconnect();
    };
  }, [pathname]);

  // Показываем блокирующий оверлей если тур активен и навигация заблокирована
  const shouldBlockInterface = isTourActive && !canNavigate;

  if (pathname === '/guest-requests' || pathname === '/create-turnover-contact') {
    return (
      <div className="standalone-layout" style={{ minHeight: '100vh', background: '#f5f5f5' }}>
        <Switch>
          <Routes />
        </Switch>
      </div>
    );
  }

  return (
    <div className={pageClassName}>
      {token && <Sidebar />}

      <section className="page__container">
        {token && <Header />}
        <div className="page__content">
          {token && <Banner />}
          <Switch>
            <Routes />
          </Switch>
          {token && <Footer />}
        </div>
      </section>

      {/* Блокирующий оверлей при активном туре */}
      {shouldBlockInterface && <div className="tour-blocking-overlay" />}
    </div>
  );
};

export default AppLayout;
